import { render, staticRenderFns } from "./CoursewareDialogCardsBlock.vue?vue&type=template&id=83322640&scoped=true&"
import script from "./CoursewareDialogCardsBlock.vue?vue&type=script&lang=js&"
export * from "./CoursewareDialogCardsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareDialogCardsBlock.vue?vue&type=style&index=0&id=83322640&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83322640",
  null
  
)

export default component.exports